import React from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import { Button } from 'swag-client-common/components/ui/button';
import { Placement } from 'swag-client-common/constants';
import { Price } from 'swag-client-common/utils/price';
import classnames from 'classnames';
import anim from '../../fade-in-out.scss';
import classes from './footer.scss';
import PriceRow from './price-row';
export const SelectCartItemsFooter = ({
  prices: {
    pricePerBox,
    setupFee,
    total
  },
  quantityOfBoxes,
  currentStep,
  isAddonFlow,
  hasUnsavedChanges,
  selectedAddonsAmount,
  shouldShowSuperSpeedBoxConfirmation,
  isAddonStepRestricted,
  isDisabledNextButton,
  boxId,
  isAdminLoggedInMode,
  onBackButton,
  onNextButton
}) => {
  let nextButtonText = isAddonFlow && !selectedAddonsAmount ? 'Skip' : 'Add to Box';
  if (boxId) {
    if (isAddonFlow) {
      nextButtonText = hasUnsavedChanges ? 'Update Box' : 'Done';
    } else {
      nextButtonText = isAddonStepRestricted ? 'Update Box' : 'Continue';
    }
  }
  const backButton = boxId && !isAddonFlow ? null : /*#__PURE__*/React.createElement(Button, {
    type: "defaultGrey",
    onClick: () => onBackButton(currentStep)
  }, "Back");
  const nextButton = /*#__PURE__*/React.createElement(Button, {
    dataButton: "Continue",
    type: "primary",
    disabled: isDisabledNextButton,
    onClick: () => onNextButton({
      boxId,
      hasUnsavedChanges,
      isAddonStepRestricted,
      shouldShowSuperSpeedBoxConfirmation
    })
  }, /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: anim,
    key: nextButtonText,
    timeout: 250
  }, /*#__PURE__*/React.createElement("span", null, nextButtonText))));
  const pricesBlock = /*#__PURE__*/React.createElement("div", {
    className: classes.prices
  }, /*#__PURE__*/React.createElement(SwitchTransition, null, /*#__PURE__*/React.createElement(CSSTransition, {
    classNames: anim,
    key: `${pricePerBox}_${setupFee}_${quantityOfBoxes}_${total}`,
    timeout: 250
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PriceRow, {
    dataText: "PricePerBox",
    value: pricePerBox,
    placement: Placement.TOP,
    text: "Price per box:",
    title: "This includes the box cost, kitting fee, and item price for each product within your box.",
    textClassName: classes.text,
    rowClassName: classes.priceRow,
    priceClassName: classes.price,
    tooltipClassName: classes.infoWrapper,
    infoButtonClassName: classes.infoButton,
    mode: "light"
  }), /*#__PURE__*/React.createElement(PriceRow, {
    dataText: "SetupFee",
    value: setupFee,
    placement: Placement.TOP,
    text: "Setup fee:",
    title: "This includes all setup fees for all products within your box. In the future when you re-order these products with the same print your setup fee will be free.",
    textClassName: classes.text,
    rowClassName: classes.priceRow,
    priceClassName: classes.price,
    tooltipClassName: classes.infoWrapper,
    infoButtonClassName: classes.infoButton,
    mode: "light"
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.priceRow
  }, /*#__PURE__*/React.createElement("span", {
    className: classes.text
  }, "Total (", quantityOfBoxes, " ", quantityOfBoxes > 1 ? 'boxes' : 'box', "):"), /*#__PURE__*/React.createElement("span", {
    className: classnames(classes.price, classes.blue),
    "data-price": "BoxTotal"
  }, Price.formatNumber(total)))))));
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.footer, {
      [classes.liftedFooter]: isAdminLoggedInMode
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.mobileOnly
  }, /*#__PURE__*/React.createElement("div", null, pricesBlock), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.buttons, {
      [classes.isSoloButton]: boxId && !isAddonFlow
    })
  }, backButton, nextButton)), /*#__PURE__*/React.createElement("div", {
    className: classes.desktopOnly
  }, /*#__PURE__*/React.createElement("div", null, backButton), /*#__PURE__*/React.createElement("div", {
    className: classes.rightSection
  }, pricesBlock, nextButton)));
};